module.exports = __webpack_public_path__ + "static/img/5913_phase_function_Paper_PointsHejduk_Prediction.7feb408.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5913_phase_function_Paper_PointsHejduk_Prediction.png
// module id = OFUj
// module chunks = 0